import React, { useRef } from "react";
import styled from "styled-components";
import Draggable from "react-draggable";
import { getWord } from "@stores/vars";
const Wrap = styled.div`
  position: relative;
  .react-draggable-dragging {
    z-index: 10;
  }
`;

const ItemView = styled.div`
  position: relative;
  width: 570px;
  height: 157px;
  line-height: 1;
  text-align: center;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 1;
  font-size: 50px;
  color: #2b2b2b;
  border-radius: 80px;
  border: 10px solid #fff;
  box-sizing: border-box;
  // font-family: "Noto Sans SC";
  background-color: ${({ color }) => color};
`;

const HitPointer = styled.div`
  position: absolute;
  width: 10px;
  height: 10px;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  opacity: 0;
`;

const DragItem = ({
  color,
  data,
  onSuccess,
  onRevert,
  isClear,
  cName,
  categoryKey,
}) => {
  const ref = useRef(null);

  const word = getWord(data.word, categoryKey); //data.word.split("|")[1];

  const onStart = () => {
    //sound.effect(require("@assets/sounds/touch.mp3"));
  };

  const onStop = (e, data) => {
    const { node } = data;
    const currentName = node.getAttribute("data-name");
    const pos = checkPosition(node);
    if (pos.isIn) {
      if (currentName === pos.isIn.getAttribute("data-name")) {
        onAccept();
      } else {
        onGoBack(true);
      }
    } else {
      onGoBack(false);
    }
  };

  const checkPosition = (me) => {
    const myRect = me.querySelector(".hit-point").getBoundingClientRect();
    const holders = document.querySelectorAll(".c-holder");

    const overlaps = Array.from(holders).filter((el) => {
      const rect = el.getBoundingClientRect();
      if (
        rect.top <= myRect.top &&
        myRect.top <= rect.bottom &&
        rect.top <= myRect.bottom &&
        myRect.bottom <= rect.bottom &&
        rect.left <= myRect.left &&
        myRect.left <= rect.right &&
        rect.left <= myRect.right &&
        myRect.right <= rect.right
      ) {
        return true;
      }
      return false;
    });

    return { isIn: overlaps[0], isDndIn: true };
  };
  // 성공처리
  const onAccept = () => {
    onSuccess(data);
  };

  // 제자리로 되돌리기
  const onGoBack = (isPlayAni) => {
    onRevert(isPlayAni);
  };

  return (
    <Wrap
      style={{
        visibility: isClear === true ? "hidden" : "visible",
      }}
    >
      <Draggable
        nodeRef={ref}
        onStart={onStart}
        onStop={onStop}
        defaultPosition={{ x: 0, y: 0 }}
        position={{ x: 0, y: 0 }}
        scale={window.__scale}
        disabled={data.isClear}
      >
        <ItemView
          ref={ref}
          data-name={word}
          className={`cha ${cName} with-block-dim`}
          color={color}
          //dangerouslySetInnerHTML={{ __html: word }}
        >
          <HitPointer className="hit-point" />
          <div dangerouslySetInnerHTML={{ __html: word }} />
        </ItemView>
      </Draggable>
    </Wrap>
  );
};

export default DragItem;
